import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

export default function UserInformationView(profile, isMaster = false) {
  const { t } = useTranslation();
  if (isMaster) {
    return [
      {
        title: "Name",
        value: profile?.userDetails?.firstName,
        testId: "profile.details.first-name",
      },
      {
        title: "LastName",
        value: profile?.userDetails?.lastName,
        testId: "profile.details.last-name",
      },
      {
        title: "Username",
        value: profile?.userDetails?.username,
        testId: "profile.details.username",
      },
      {
        title: "Oib",
        value: profile?.userDetails?.oib,
        testId: "profile.details.oib",
      },
      {
        title: "IdCardNumber",
        value: profile?.userDetails?.idCardNumber,
        testId: "profile.details.id-card-number",
      },
      { title: "Role", value: profile?.role, testId: "profile.details.role" },
      {
        title: "DoB",
        value: profile?.userDetails?.birthday
          ? dayjs(profile?.userDetails?.birthday, "DD/MM/YYYY", true).format(
              "DD/MM/YYYY",
            )
          : null,
        testId: "profile.details.dob",
      },
      {
        title: "PhoneNumber",
        value: profile?.userDetails?.phoneNumber,
        testId: "profile.details.phone-number",
      },
      {
        title: "Clinic",
        value: profile?.clinic?.title,
        testId: "profile.details.clinic",
      },
      {
        title: "Email",
        value: profile?.userDetails?.email,
        testId: "profile.details.email",
      },
      {
        title: "Address",
        value: profile?.userDetails?.location?.address,
        testId: "profile.details.address",
      },
      {
        title: "Country",
        value: t(profile?.location?.country),
        testId: "profile.details.country",
      },
      {
        title: "City",
        value: profile?.location?.city,
        testId: "profile.details.city",
      },
      {
        title: "Province",
        value: profile?.location?.province,
        testId: "profile.details.province",
      },
      {
        title: "Place",
        value: profile?.location?.place,
        testId: "profile.details.place",
      },
      {
        title: "ZipCode",
        value: profile?.location?.zipcode,
        testId: "profile.details.zip-code",
      },
    ].filter(
      (val) => val.value != null && val.value != undefined && val.value != "",
    );
  }
  return [
    {
      title: "Name",
      value: profile?.firstName,
      testId: "profile.details.first-name",
    },
    {
      title: "LastName",
      value: profile?.lastName,
      testId: "profile.details.last-name",
    },
    {
      title: "Username",
      value: profile?.username,
      testId: "profile.details.username",
    },
    {
      title: "Oib",
      value: profile?.oib,
      testId: "profile.details.oib",
    },
    {
      title: "IdCardNumber",
      value: profile?.idCardNumber,
      testId: "profile.details.id-card-number",
    },
    {
      title: "DoB",
      value: profile?.birthday
        ? dayjs(profile?.birthday).format("DD/MM/YYYY")
        : null,
      testId: "profile.details.dob",
    },
    {
      title: "PhoneNumber",
      value: profile?.phoneNumber,
      testId: "profile.details.phone-number",
    },
    {
      title: "Clinic",
      value: profile?.currentClinic?.title,
      testId: "profile.details.clinic",
    },
    {
      title: "Email",
      value: profile?.email,
      testId: "profile.details.email",
    },
    {
      title: "Address",
      value: profile?.location?.address,
      testId: "profile.details.address",
    },
    {
      title: "Country",
      value: t(profile?.location?.country),
      testId: "profile.details.country",
    },
    {
      title: "City",
      value: profile?.location?.city,
      testId: "profile.details.city",
    },
    {
      title: "Province",
      value: profile?.location?.province,
      testId: "profile.details.province",
    },
    {
      title: "Place",
      value: profile?.location?.place,
      testId: "profile.details.place",
    },
    {
      title: "ZipCode",
      value: profile?.location?.zipcode,
      testId: "profile.details.zip-code",
    },
  ].filter(
    (val) => val.value != null && val.value != undefined && val.value != "",
  );
}
